export default function isPrintMode(): boolean {
  return !!(
    window.CultureAmp &&
    window.CultureAmp.environment &&
    window.CultureAmp.environment.print
  );
}
